import React from 'react';
import {
  RandomIcon,
  LeftIcon,
  RightIcon,
  RoundTripIconEn,
  RoundTripIconFa,
} from '~svg/index';
import { Loading } from '../../../common';
const FlightSearchLoading = ({
  isMobileDevice,
  direction,
  name,
  selectedAirport,
  flightType,
}) => {
  return (
    <div
      className={`d-flex justify-content-between align-items-center flex-column w-100 pt-5 `}
      style={{ direction, zIndex: 0 }}
    >
      <div
        className="d-flex font-weight-bold text-primary h3 justify-content-between position-relative pt-5"
        style={{ zIndex: 2 }}
      >
        <img
          loading="lazy"
          src={require('../../../../content/images/icon/wait.gif')}
          alt="wait"
          className={`${isMobileDevice ? 'w-75' : ' w-100 '} px-2`}
          style={{
            transform: `translate(0, -48%) ${
              name === 'fa' ? ' rotateY(180deg)' : ''
            }`,
          }}
        />
        <div className="d-flex flex-column w-100 pt-5 position-absolute justify-content-center align-items-center  ">
          {/* show all flights in loading */}
          {selectedAirport && Object.entries(selectedAirport).length && (
            <div
              key={`airportSelected`}
              style={{ zIndex: '2', fontSize: '0.8rem' }}
              className={`d-flex flex-row justify-content-center  align-items-center  col-12`}
            >
              <span
                className={` text-uppercase  text-primary font-weight-bold  px-1 text-center col-5 p-0 m-0`}
              >
                {` ${selectedAirport[0].origin.city.locationName[name]} `}
              </span>
              <div
                style={{
                  transform:
                    (selectedAirport.length > 2 ||
                      flightType === 'multicity') &&
                    direction === 'rtl'
                      ? 'rotate( 180deg )'
                      : 'rotate( 360deg )',
                }}
              >
                {selectedAirport.length === 1 ? (
                  direction === 'rtl' ? (
                    <LeftIcon size={20} color="#aaacaf" />
                  ) : (
                    <RightIcon size={20} color="#aaacaf" />
                  )
                ) : selectedAirport.length === 2 &&
                  flightType !== 'multicity' ? (
                  direction === 'rtl' ? (
                    <RoundTripIconFa size={24} color="#aaacaf" />
                  ) : (
                    <RoundTripIconEn size={24} color="#aaacaf" />
                  )
                ) : (
                  <RandomIcon size={20} color="#aaacaf" />
                )}
              </div>
              <span className=" px-1  col-5 p-0 m-0 text-center text-uppercase">
                {` ${
                  selectedAirport.length > 2 || flightType === 'multicity'
                    ? selectedAirport[selectedAirport.length - 1].destination
                        .city.locationName[name]
                    : selectedAirport[0].destination.city.locationName[name]
                } `}
              </span>
            </div>
          )}
        </div>
      </div>

      <div
        className={`d-flex col-7 col-md-3 p-0 mt-3 position-relative justify-content-center `}
      >
        <Loading language={{ name, direction }} />
      </div>
    </div>
  );
};
export default FlightSearchLoading;
